import { render } from "./MovAlmacenDetalle.vue?vue&type=template&id=f8f2c27e"
import script from "./MovAlmacenDetalle.vue?vue&type=script&lang=js"
export * from "./MovAlmacenDetalle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__